import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import QuestionTimer from "../components/exam/QuestionTimer";
import QuestionContent from "../components/exam/QuestionContent";
import QuestionControls from "../components/exam/QuestionControls";
import ReviewPage from "./ReviewPage";
import { Logout } from "iconsax-react";
import { LogOutIcon } from "lucide-react";

const ExamLayout = () => {
  const { examId } = useParams();
  const navigate = useNavigate();

  const [examData, setExamData] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [showReview, setShowReview] = useState(false);

  useEffect(() => {
    // داده تستی شبیه‌سازی شده
    const mockExam = {
      _id: examId,
      title: "TPO 01 - Mixed Types",
      duration: 60,
      type: "test",
      questions: [
        {
          _id: "q1",
          type: "multiple_choice",
          text: "Which of the following can be inferred from paragraph 1 about the ground that we walk on?",
          options: [
            "It cannot hold rainwater for long periods of time.",
            "It prevents most groundwater from circulating.",
            "It has the capacity to store large amounts of water.",
            "It absorbs most of the water it contains from rivers.",
          ],
        },
        {
          _id: "q2",
          type: "true_false",
          text: "The sun is the primary source of energy for the Earth's climate system.",
        },
        {
          _id: "q3",
          type: "matching",
          text: "Match the animals with their habitats.",
          pairs: [
            { left: "Polar Bear", right: "Arctic" },
            { left: "Camel", right: "Desert" },
            { left: "Frog", right: "Wetlands" },
            { left: "Eagle", right: "Mountains" },
          ],
        },
        {
          _id: "q4",
          type: "image",
          text: "Click on the image that shows the Mona Lisa painting.",
          options: [
            "/images/image1.jpg",
            "/images/image2.jpg",
            "/images/monalisa.jpg",
            "/images/image4.jpg",
          ],
        },
        {
          _id: "q5",
          type: "audio",
          text: "Listen to the conversation and answer the question.",
          audioUrl: "/audio/sample1.mp3",
          options: [
            "The woman is asking for directions.",
            "The man is giving advice about a job interview.",
            "They are talking about weather conditions.",
            "They are planning a holiday trip.",
          ],
        },
        {
          _id: "q6",
          type: "video",
          text: "Watch the following video and choose the main topic.",
          videoUrl: "/videos/environment.mp4",
          options: [
            "The importance of recycling",
            "History of climate change",
            "Benefits of electric cars",
            "Global warming impacts on wildlife",
          ],
        },
        {
          _id: "q7",
          type: "text",
          text: "Explain in your own words how photosynthesis works.",
        },
      ],
    };

    setExamData(mockExam);
    setUserAnswers(new Array(mockExam.questions.length).fill(null));
  }, [examId]);

  const handleAnswer = (value) => {
    const updated = [...userAnswers];
    updated[currentQuestionIndex] = value;
    setUserAnswers(updated);
  };

  const next = () => {
    if (currentQuestionIndex < examData.questions.length - 1)
      setCurrentQuestionIndex((prev) => prev + 1);
  };

  const back = () => {
    if (currentQuestionIndex > 0) setCurrentQuestionIndex((prev) => prev - 1);
  };

  const exitExam = () => {
    if (window.confirm("آیا مطمئن هستید که می‌خواهید از آزمون خارج شوید؟")) {
      navigate("/");
    }
  };

  const goToReview = () => setShowReview(true);
  const goToQuestion = (i) => {
    setCurrentQuestionIndex(i);
    setShowReview(false);
  };

  if (!examData)
    return (
      <div className="p-6 text-center text-gray-600">
        در حال بارگذاری آزمون...
      </div>
    );

  if (showReview) {
    return (
      <ReviewPage
        questions={examData.questions}
        answers={userAnswers}
        onSelect={goToQuestion}
        onExit={() => setShowReview(false)} // این دکمه خروج را هدایت می‌کند
      />
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white text-right">
      {/* 🔻 هدر با دکمه‌ها بالا راست و تایمر وسط */}
      <div className="flex justify-between items-center px-6 py-4 border-b shadow sticky top-0 z-10 bg-white">
        <div className="flex items-center gap-4">
          <QuestionTimer duration={examData.duration} />
          <span className="text-sm text-gray-600">
            سوال {currentQuestionIndex + 1} از {examData.questions.length}
          </span>
          <button
            onClick={exitExam}
            className="bg-red-100 text-red-700 px-3 flex gap-1 items-center py-1 rounded-md text-sm hover:bg-red-200"
          >
            خروج <LogOutIcon />
          </button>
        </div>

        <div className="flex gap-2">
          {!currentQuestionIndex === 0 ? null : (
            <button
              onClick={back}
              className="px-4 py-2 text-sm rounded-md bg-gray-100 hover:bg-gray-200 border"
            >
              قبلی
            </button>
          )}
          {currentQuestionIndex < examData.questions.length - 1 && (
            <button
              onClick={next}
              className="px-4 py-2 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
            >
              بعدی
            </button>
          )}
          <button
            onClick={goToReview}
            className="px-4 py-2 text-sm rounded-md bg-purple-600 text-white hover:bg-purple-700"
          >
            مرور آزمون
          </button>
        </div>
      </div>

      {/* 🔻 سوال وسط صفحه */}
      <div className="flex-1 px-6 py-8 max-w-4xl mx-auto w-full">
        <QuestionContent
          question={examData.questions[currentQuestionIndex]}
          answer={userAnswers[currentQuestionIndex]}
          onAnswer={handleAnswer}
        />
      </div>
    </div>
  );
};

export default ExamLayout;
